export const POST_LOCATION = 'POST_LOCATION';
export const LIST_LOCATION = 'LIST_LOCATION';
export const LIST_LOCATION_BREADCRUMBS = 'LIST_LOCATION_BREADCRUMBS';
